module.exports = __webpack_public_path__ + "chevron-left-smooth.svg?f00e08df2d8d81cb17cd063a400011a1";